import { checkIsInternal } from '@src/utility/createStorage';
import HttpService from '@src/utility/httpService';
import { removeSierraFromClaimSystems } from '@src/utility/commonUtilityServices';
import { config } from '@uhg-abyss/web/tools/config';
import {
  REIUMBURSEMENT_TAB_DATA_OVERVIEW_API,
  REIUMBURSEMENT_TAB_DATA_METRICS_API,
  REIUMBURSEMENT_TAB_APPEALS_DETAILS_API,
  REIUMBURSEMENT_TAB_RECONSIDERATION_DETAILS_API,
  REIUMBURSEMENT_TAB_DATA_DOP_FILTERS_API,
  REIUMBURSEMENT_TAB_NONPAYMENT_API,
  REIUMBURSEMENT_TAB_NONPAYMENT_BULK_API,
  REIUMBURSEMENT_TAB_RECONSIDERATION_DETAILS_API_BULK,
  REIUMBURSEMENT_TAB_DATA_DOP_BULK_FILTERS_API
} from './apiUrlConstants';

const _httpService = new HttpService();
const cache = new Map();
const bulkProcessingURL = config('BULK_PROCESSING_API') || '';

const apiDomainInternal = config('API_DOMAIN_INTERNAL') ?? '';
const apiDomainExternal = config('API_DOMAIN_EXTERNAL') ?? '';

if (checkIsInternal()) {
  _httpService.setBaseURL(config('API_DOMAIN_INTERNAL') || '');
} else {
  _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL') || '');
  //_httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
}

export const getReiumbursementTabData = async (payload: any, highVolumeTinFlag: boolean) => {    
  if (highVolumeTinFlag) { 
    // Define bulkProcessingURL (replace with actual value or import as needed)

    _httpService.setBaseURL(bulkProcessingURL);
    
    //const url = `${REIUMBURSEMENT_TAB_DATA_OVERVIEW_API}`;
    const url = `claims-bulk-process-jobs/${REIUMBURSEMENT_TAB_DATA_OVERVIEW_API}`;
    try {
      const responseData: any = await _httpService.push(url, payload);
      // Restore base URL
      setBaseUrl();
      return responseData;
    } catch (error: any) {
      trackPollingErrrors(error, payload, url);  
      setBaseUrl();
      
      throw error;
    }
  } else {
    const url = REIUMBURSEMENT_TAB_DATA_OVERVIEW_API;
    try {
      const responseData: any = await _httpService.push(url, payload);
      return responseData;
    } catch {
      return null;
    }
  }

};
export const getReiumbursementTabDataMetrics = async (payload: any, highVolumeTinFlag: boolean) => {
  if (highVolumeTinFlag) {
    _httpService.setBaseURL(bulkProcessingURL);
    
    const url = `claims-bulk-process-jobs/dos-claim-metrics?request-type=PAYMENT_METRICS`;
    try {
      const responseData: any = await _httpService.push(url, payload);
      setBaseUrl();
      return responseData;
    } catch (error: any) {
      trackPollingErrrors(error, payload, url);  
      setBaseUrl();
      throw error;
    }
  } else {
    const url = REIUMBURSEMENT_TAB_DATA_METRICS_API;
    try {
      const responseData: any = await _httpService.push(url, payload);
      return responseData;
    } catch {
      return null;
    }
  }

};

export const getReiumbursementAppealsTabData = async (payload:any, highVolumeTinFlag: boolean) =>{
   if (highVolumeTinFlag) { 
    _httpService.setBaseURL(bulkProcessingURL);
    const url = REIUMBURSEMENT_TAB_APPEALS_DETAILS_API;
    let finalUrl = url;

    if (payload?.queryParam && typeof payload.queryParam === 'object') {
      const queryParams = new URLSearchParams(payload.queryParam).toString();
      if (queryParams) {
          finalUrl = `appeals-bulk-process-jobs/${url}?${queryParams}`;
      }
    }
    try {
      const responseData: any = await _httpService.push(finalUrl, payload?.requestBody);
      setBaseUrl();
      return responseData;
    } catch (error: any) {
      trackPollingErrrors(error, payload, url);
      setBaseUrl();
      
      throw error;
    }
  } else {
    const url = REIUMBURSEMENT_TAB_APPEALS_DETAILS_API;
    let finalUrl = url;

    if (payload?.queryParam && typeof payload.queryParam === 'object') {
      const queryParams = new URLSearchParams(payload.queryParam).toString();
      if (queryParams) {
          finalUrl = `${url}?${queryParams}`;
      }
    }

    try {
      const responseData: any = await _httpService.push(finalUrl, payload?.requestBody);
      return responseData;
    } catch {
      return null;
    }
  }
}

export const getReiumbursementReconsiderationTabData = async (payload: any, highVolumeTinFlag: boolean) => {

  // Filter ClaimSystems remove Sierra
  payload.ClaimSystems = removeSierraFromClaimSystems(payload.ClaimSystems);


  if (highVolumeTinFlag) { 
    _httpService.setBaseURL(bulkProcessingURL);
    const url = `claims-bulk-process-jobs/${REIUMBURSEMENT_TAB_RECONSIDERATION_DETAILS_API_BULK}`;
    try {
      const responseData: any = await _httpService.push(url, payload);
      setBaseUrl();
      
      return responseData;
    } catch (error: any) {
      trackPollingErrrors(error, payload, url);
      setBaseUrl();
      throw error;     
    }
  } else {
    const url = REIUMBURSEMENT_TAB_RECONSIDERATION_DETAILS_API;
    try {
      const responseData: any = await _httpService.push(url, payload);
      return responseData;
    } catch {
      return null;
    }
  }
  
};

export const getReiumbursementTabsDataDopFilters = async (payload: any, highVolumeTinFlag: boolean) => {
  if (highVolumeTinFlag) {
    _httpService.setBaseURL(bulkProcessingURL);
    const url = `claims-bulk-process-jobs/${REIUMBURSEMENT_TAB_DATA_DOP_BULK_FILTERS_API}`;
    try {
      const responseData: any = await _httpService.push(url, payload);
      setBaseUrl();
      return responseData;
    } catch (error: any) {
      trackPollingErrrors(error, payload, url);  
      setBaseUrl();
      throw error;
    }
  } else {
    const url = REIUMBURSEMENT_TAB_DATA_DOP_FILTERS_API;
    try {
      const responseData: any = await _httpService.push(url, payload);
      return responseData;
    } catch {
      return null;
    }  
  }
};

export const getReiumbursementNonPaymentTabData = async (payload: any, highVolumeTinFlag: boolean) => {
  if (highVolumeTinFlag) { 
    _httpService.setBaseURL(bulkProcessingURL);
    const url = `claims-bulk-process-jobs/${REIUMBURSEMENT_TAB_NONPAYMENT_BULK_API}`;
    try {
      const responseData: any = await _httpService.push(url, payload);
      setBaseUrl();
      return responseData;
    } catch (error: any) {
      trackPollingErrrors(error, payload, url);  
      setBaseUrl();
      throw error;
    }
  } else {
    const url = REIUMBURSEMENT_TAB_NONPAYMENT_API;
    try {
      const responseData: any = await _httpService.push(url, payload);
      return responseData;
    } catch {
      return null;
    }
  }
};

const trackPollingErrrors = (error: any, payload: any, url: string) => {
  console.error('Claims Processed Bulk Service Error:', {
    error: error?.message || error,
    status: error?.status || error?.response?.status,
    url,
    payload
  });
};

const setBaseUrl = () => {
  if (checkIsInternal()) {
    _httpService.setBaseURL(apiDomainInternal);
  } else {
    _httpService.setBaseURL(apiDomainExternal);
  }
};
